import { ReactNode, useState } from 'react';

import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';

import { InstructionsModal } from '../InstructionsModal';

interface Props {
  children: ReactNode;
}

export const Layout = ({ children }: Props) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="h-screen w-screen grid grid-rows-[max-content_auto] pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]">
      <div className="grid grid-cols-[minmax(auto,_1200px)] justify-center items-center">
        <div className="grid grid-rows-[max-content_max-content] gap-x0_5 md:grid-rows-[auto] md:grid-cols-[max-content_max-content] md:gap-x5 md:items-center px-x3 py-x3 md:py-x4">
          <h1 className="text-xl text-solid m-0">
            <strong>Add your transactions</strong>
          </h1>
          <button
            className="grid grid-cols-[max-content_max-content] gap-x0_75 items-center"
            onClick={() => setShowModal(true)}
          >
            <p className="m-0 text-soft text-xs">
              How to find and prepare your transactions
            </p>
            <InformationSolid className="fill-soft" />
          </button>
        </div>
      </div>
      {children}
      {showModal && <InstructionsModal onClose={() => setShowModal(false)} />}
    </div>
  );
};
